import { gql } from '@apollo/client'

export const CANCEL_USER_ACTIVE_CART = gql`
  mutation CancelUserActiveCart($cartId: ID!) {
    cancelCart(input: { cartId: $cartId }) {
      ... on CartMutationSuccess {
        cart {
          id
          status
        }
      }

      ... on CartMutationFailure {
        errorMessage
        fieldsErrors {
          field
          messages
        }
      }
    }
  }
`

export const CANCEL_CART = gql`
  mutation UpdateCart($cartId: ID!) {
    cancelCart(input: { cartId: $cartId }) {
      ... on CartMutationSuccess {
        cart {
          id
          status
        }
      }

      ... on CartMutationFailure {
        errorMessage
        fieldsErrors {
          field
          messages
        }
      }
    }
  }
`

export const ADD_TO_CART = gql`
  mutation CreateCart($packageId: ID, $quantity: Int!, $tevoTicketGroupId: ID) {
    createCart(
      input: { packageId: $packageId, quantity: $quantity, tevoTicketGroupId: $tevoTicketGroupId }
    ) {
      ... on CartMutationSuccess {
        cart {
          id
        }
      }

      ... on CartMutationFailure {
        errorMessage
      }
    }
  }
`
